import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppBar, Toolbar, Paper, Tooltip, Typography, TextField, Container, Button } from '@mui/material';
import {
  FormControl, Box, Modal,
  InputLabel,
  MenuItem,
  Select,

} from '@mui/material';
import { Navigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const EditState = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [stateName, setStateName] = useState('');
  const [countryId, setCountryId] = useState('');
  const [stateDetails, setStateDetails] = useState([]);
  const { stateId } = useParams();
  const [data, setData] = useState([]);
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  let navigate = useNavigate();


  const fetchStateData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/State/GetState`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (response.ok) {
        const responseData = await response.json();
        setStateDetails(responseData);
        setLoadingBarProgress(100);
      } else {
        console.error('Failed to fetch state data');
        setLoadingBarProgress(0);
      }
    } catch (error) {
      console.error('API request error:', error);
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  useEffect(() => {
    fetchStateData();
  }, []);

  useEffect(() => {
    const state = stateDetails.find(state => state.stateId === parseInt(stateId));
    if (state) {
      setStateName(state.stateName);
      setCountryId(state.countryId);
    } else {
      console.error('State not found');
    }
  }, [stateId, stateDetails]);


  const fetchCountryData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Country/GetCountry`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        const responseData = await response.json();
        setData(responseData);
        setLoadingBarProgress(100);

      } else {
        console.error('Country name incorrect');
        setSnackbarMessage('Invalid country name');
        setOpenSnackbar(true);
        setSnackbarSeverity("warning");
        setLoadingBarProgress(0);
      }
    } catch (error) {
      console.error('API request error:', error);
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };




  const handleUpdate = async () => {
    try {
      const token = sessionStorage.getItem('token');
      setLoadingBarProgress(30);
      const apiUrl = process.env.REACT_APP_BASE_URL;

      const response = await fetch(`${apiUrl}/State/Id?StateId=${stateId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          stateName,
          countryId: countryId,
        }),
      });

      const data = await response.json();
      setLoadingBarProgress(100);

      const message = (data && (data.msg || data.message)) || 'State has been updated successfully.';
      const status = (data && data.status && data.status.toString().toLowerCase()) || '';
      const lowerMsg = (message || '').toString().toLowerCase();
      const errorKeywords = ['already exist', 'already exists', 'failed', 'error', 'unable', 'cannot'];
      const messageHasError = status.includes('failed') || errorKeywords.some(k => lowerMsg.includes(k));

      setModalType(messageHasError ? 'error' : 'success');
      setModalMessage(message);
      setModalOpen(true);
    } catch (error) {
      console.error('API request error:', error);
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };
  useEffect(() => {

    fetchCountryData(); // Fetch country data when the component mounts
  }, []); // Empty dependency array ensures the effect runs only once

  return (
    <Container>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Edit State
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <FormControl fullWidth sx={{ my: 2 }}>
          <InputLabel htmlFor="country">Country:</InputLabel>
          <Select
            id="country"
            value={countryId}
            label="Country"
            onChange={(e) => setCountryId(e.target.value)}
          >
            {data.map((countryItem) => (
              <MenuItem key={countryItem.countryId} value={countryItem.countryId}>
                {countryItem.countryName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          fullWidth
          id="stateName"
          label="State Name"
          variant="outlined"
          margin="normal"
          value={stateName}
          onChange={(e) => setStateName(e.target.value)}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px', marginTop: '16px' }}>
          <Tooltip title={!stateName && "Enter State Name"} arrow>
            <span><Button variant="contained" color="primary" disabled={!countryId || !stateName} onClick={handleUpdate}>
              Update
            </Button></span></Tooltip>
          <Button variant="contained" color="error" onClick={handleCancel}>
            Cancel
          </Button>
        </div>
      </Paper>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: modalType === 'error' ? '#8B0000' : '#0B1F40', padding: '12px 16px' }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'error' ? 'Error ❌' : 'State Updated ✅'}
            </Typography>
          </Box>

          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage || (modalType === 'error' ? 'An error occurred.' : 'State has been updated successfully.')}
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType !== 'error') navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default EditState;
